module.exports = __webpack_public_path__ + "static/titlebar-skeleton-b142a7aab8a0ffe161c4188b6306f369.jpg";